var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container postage-recharge-page" },
    [
      _c("BjDivider", [_vm._v(_vm._s(_vm.$t("billingPage.PostageRecharge")))]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "serial-fixed": "left",
          selection: _vm.selection,
          res: "page",
          "reset-data": _vm.adaptInvoiceRows,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.PostageRechargeCarrier"),
                          prop: "logisticsCompany",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: "",
                            "option-list": _vm.companyList,
                            placeholder: _vm.$t(
                              "billingPage.PostageRechargeAllPartners"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsCompany", $$v)
                            },
                            expression: "queryParams.logisticsCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.YearWeek"),
                          prop: "week",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          ref: "weekPicker",
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "week",
                            format: "yyyy-WW",
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.changeWeek },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.PostageRechargeInvoiceNo"),
                          prop: "invoiceNumber",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "billingPage.PostageRechargeSearchInvoice"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.invoiceNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "invoiceNumber", $$v)
                            },
                            expression: "queryParams.invoiceNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableTop",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "recharge-summary" },
                  _vm._l(_vm.summaryCards, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.key,
                        staticClass: "recharge-summary__item",
                        class: item.className,
                      },
                      [
                        _c("div", { staticClass: "recharge-summary__label" }, [
                          _vm._v(_vm._s(item.label)),
                        ]),
                        _c("div", { staticClass: "recharge-summary__value" }, [
                          _vm._v(_vm._s(item.value)),
                        ]),
                        _c("div", { staticClass: "recharge-summary__desc" }, [
                          _vm._v(_vm._s(item.desc)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: {
                          type: "primary",
                          icon: "el-icon-plus",
                          loading: _vm.carrierOptionsLoading,
                        },
                        on: { click: _vm.showUploadDialog },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("billingPage.PostageRechargeNewInvoice")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            field: col.prop,
                            title: col.label,
                            "min-width": col.minWidth || col.width || 120,
                            fixed: col.fixed || false,
                            align: _vm.getColumnAlign(),
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "postage-table-header__label",
                                        attrs: { title: col.label },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(col.shortLabel || col.label)
                                        ),
                                      ]
                                    ),
                                    col.formula
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "formula-tooltip",
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.formulaDefinitions[
                                                          col.formula
                                                        ].labelKey
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.formulaDefinitions[
                                                          col.formula
                                                        ].descriptionKey
                                                      )
                                                    )
                                                ),
                                                _c("br"),
                                                _c("br"),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.formulaDefinitions[
                                                          col.formula
                                                        ].formulaKey
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-info formula-info",
                                              attrs: { tabindex: "0" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop === "invoiceNumber"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onView(scope.row)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.invoiceNumber)
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "yearWeek"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatYearWeek(scope.row)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _vm.moneyProps.includes(col.prop)
                                      ? [
                                          col.prop === "currentChargeAmount"
                                            ? _c(
                                                "el-popover",
                                                {
                                                  attrs: {
                                                    placement: "bottom-end",
                                                    width: "300",
                                                    trigger: "click",
                                                    "popper-class":
                                                      "postage-calculation-popover",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "calculation-breakdown",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "calculation-breakdown__title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "billingPage.PostageRechargeCalculationBreakdown"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "billingPage.PostageRechargeCalculatedFromOrders"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onView(
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "billingPage.PostageRechargeViewOrderBreakdown"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "semantic-value is-clickable",
                                                      class: _vm.getCellClass(
                                                        scope.row,
                                                        col.prop
                                                      ),
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      slot: "reference",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatMoney(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm.getValidationError(
                                                scope.row,
                                                col.prop
                                              )
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    effect: "dark",
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      attrs: {
                                                        slot: "content",
                                                      },
                                                      slot: "content",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "billingPage.PostageRechargeValidationFailed"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                      _c("br"),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getValidationMessage(
                                                              scope.row,
                                                              col.prop
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "billingPage.PostageRechargeExpected"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm.formatMoney(
                                                              _vm.getValidationError(
                                                                scope.row,
                                                                col.prop
                                                              ).expectedValue
                                                            )
                                                          )
                                                      ),
                                                      _c("br"),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "billingPage.PostageRechargeActual"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm.formatMoney(
                                                              _vm.getValidationError(
                                                                scope.row,
                                                                col.prop
                                                              ).actualValue
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "semantic-value is-invalid",
                                                      class: _vm.getCellClass(
                                                        scope.row,
                                                        col.prop
                                                      ),
                                                      on: {
                                                        mouseenter: function (
                                                          $event
                                                        ) {
                                                          return _vm.setActiveFormula(
                                                            scope.row,
                                                            col.prop
                                                          )
                                                        },
                                                        mouseleave:
                                                          _vm.clearActiveFormula,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-warning-outline",
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatMoney(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass: "semantic-value",
                                                  class: _vm.getCellClass(
                                                    scope.row,
                                                    col.prop
                                                  ),
                                                  on: {
                                                    mouseenter: function (
                                                      $event
                                                    ) {
                                                      return _vm.setActiveFormula(
                                                        scope.row,
                                                        col.prop
                                                      )
                                                    },
                                                    mouseleave:
                                                      _vm.clearActiveFormula,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatMoney(
                                                          scope.row[col.prop]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ]
                                      : col.prop === "averageProfitMargin"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "semantic-value is-margin",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatPercent(
                                                      scope.row
                                                        .averageProfitMargin
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "gmtCreate"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  scope.row.gmtCreate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row[col.prop]) +
                                              " "
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            field: col.prop,
                            title: col.label,
                            width: Math.max(Number(col.width) || 0, 230),
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$refs.InvoiceReviewDialog.show(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "billingPage.postageReview.title"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDelete(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delText")))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("UploadInvoiceDialog", {
        ref: "UploadInvoiceDialog",
        attrs: { "company-list": _vm.companyList },
        on: { refresh: _vm.handleQuery },
      }),
      _c("InvoiceReviewDialog", {
        ref: "InvoiceReviewDialog",
        on: { loaded: _vm.onReviewLoaded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }